var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimesCircleRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a3acb4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17,8a9,9,0,1,0,9,9A9,9,0,0,0,17,8Zm0,16.258A7.258,7.258,0,1,1,24.258,17,7.256,7.256,0,0,1,17,24.258Zm3.694-9.515L18.437,17l2.257,2.257a.436.436,0,0,1,0,.617l-.82.82a.436.436,0,0,1-.617,0L17,18.437l-2.257,2.257a.436.436,0,0,1-.617,0l-.82-.82a.436.436,0,0,1,0-.617L15.563,17l-2.257-2.257a.436.436,0,0,1,0-.617l.82-.82a.436.436,0,0,1,.617,0L17,15.563l2.257-2.257a.436.436,0,0,1,.617,0l.82.82a.436.436,0,0,1,0,.617Z",
    transform: "translate(-8 -8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesCircleRegular);
export default __webpack_public_path__ + "static/media/times-circle-regular.f5231b70e15b551dc3cca7c5877e90b5.svg";
export { ForwardRef as ReactComponent };